import { StreamingProvider } from "@switcherstudio/switcher-api-client";
import { PlatformId } from "views/page-content/platforms/types";

export type InstagramConnectState = "connected" | "connect" | "needs-facebook";

export type WithNeedsFacebook<T> = T & { NeedsFacebook?: boolean };

export function getInstagramConnectState(
    instagramLinked: boolean | undefined,
    facebookLinked: boolean | undefined
): InstagramConnectState {
    if (instagramLinked) return "connected";
    return facebookLinked ? "connect" : "needs-facebook";
}

export function isInstagramEnabled(
    providers: StreamingProvider[] | undefined
): boolean {
    return !!providers?.some((p) => p.Id === PlatformId.Instagram);
}

export function markInstagramNeedsFacebook<T extends StreamingProvider>(
    providers: T[]
): WithNeedsFacebook<T>[] {
    const facebookLinked = providers.find(
        (p) => p.Id === PlatformId.Facebook
    )?.IsLinked;

    return providers.map((p) =>
        p.Id === PlatformId.Instagram
            ? {
                  ...p,
                  NeedsFacebook:
                      getInstagramConnectState(p.IsLinked, facebookLinked) ===
                      "needs-facebook"
              }
            : p
    );
}
